import React,{useEffect} from "react";
import { useSelector } from "react-redux";
import {addBreadcrumb} from "../../components/Breadcrumbs/reducer/breadcrumbSlice";
import store from "../../store/store";
const MyProfile: React.FC<any> = () => {
    const { profileData } = useSelector((state: any) => state.rootReducer?.auth ?? {});
    useEffect(() => {
      const data: any = [
        {
          label: "My Profile",
          link: `/my-profile`,
        },
      ];
      store.dispatch(addBreadcrumb(data));
    }, []);

    return (
        <div className="my-profile p-6 bg-gray-100 min-h-screen">
            {/* <h1 className="text-3xl font-bold text-gray-800 mb-6">My Profile</h1> */}
            <div className="profile-card bg-white shadow-md rounded-lg p-6">
                <div className="profile-header mb-6">
                    <h2 className="text-2xl font-semibold text-gray-800">
                        {profileData?.firstName} {profileData?.lastName}
                    </h2>
                    <p className="profile-role text-gray-600 text-sm">{profileData?.role}</p>
                </div>
                <div className="profile-body space-y-4">
                    <div className="profile-item flex justify-between">
                        <span className="profile-label font-medium text-gray-700">Email:</span>
                        <span className="profile-value text-gray-800">{profileData?.email}</span>
                    </div>
                    <div className="profile-item flex justify-between">
                        <span className="profile-label font-medium text-gray-700">Status:</span>
                        <span
                            className={`profile-value font-semibold ${
                                profileData?.status ? "text-green-600" : "text-red-600"
                            }`}
                        >
                            {profileData?.status ? "Active" : "Inactive"}
                        </span>
                    </div>
                    <div className="profile-item flex justify-between">
                        <span className="profile-label font-medium text-gray-700">Last Login:</span>
                        <span className="profile-value text-gray-800">
                            {new Date(profileData?.lastLogin).toLocaleString()}
                        </span>
                    </div>
                    <div className="profile-item flex justify-between">
                        <span className="profile-label font-medium text-gray-700">Account Created:</span>
                        <span className="profile-value text-gray-800">
                            {new Date(profileData?.createdAt).toLocaleString()}
                        </span>
                    </div>
                    <div className="profile-item flex justify-between">
                        <span className="profile-label font-medium text-gray-700">Last Updated:</span>
                        <span className="profile-value text-gray-800">
                            {new Date(profileData?.updatedAt).toLocaleString()}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;